<div  class="margin-bottom-20 flex-center time-input">
    <div class="align-center">
        <button type="button" class="btn btn--square-small transform-up" (click)="increaseHour()">
            <span class="icon icon-arrow-right-link"></span>
        </button>
        <ridango-form-field class="no-margin">
            <input [formControl]="hour" (keydown.arrowup)="increaseHour()" (keydown.arrowdown)="decreaseHour()"
                (blur)="validateHour($event)" ridangoInput ridangoUntouchOnFocusout>
            <!--<ridango-label>{{ hourLabel }}</ridango-label>-->
        </ridango-form-field>
        <button type="button" class="btn btn--square-small transform-down" (click)="decreaseHour()">
            <span class="icon icon-arrow-right-link transform-up"></span>
        </button>
    </div>

    <div class="align-center"><span class="bold time-input-separator">:</span></div>

    <div class="align-center">
        <button type="button" class="btn btn--square-small transform-up" (click)="increaseMinutes()">
            <span class="icon icon-arrow-right-link transform-up"></span>
        </button>
        <ridango-form-field class="no-margin">
            <input [formControl]="minute" (keydown.arrowup)="increaseMinutes()" (keydown.arrowdown)="decreaseMinutes()"
            (blur)="validateMinute($event)" ridangoInput ridangoUntouchOnFocusout>
            <!--<ridango-label>{{ minuteLabel }}</ridango-label>-->
        </ridango-form-field>
        <button type="button" class="btn btn--square-small transform-down" (click)="decreaseMinutes()">
            <span class="icon icon-arrow-right-link transform-up"></span>
        </button>
    </div>
</div>
